'use client';

// Third Party
import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Image from 'next/image';
import { GalleryAsset } from '@gql';

// Utils
import { GRAY_PIXEL_DATA_URL } from '@utils/constants';
import { imagekitLoader } from '@utils/imagekit-loader';
import { notEmpty } from '@utils/not-empty';

// UI
import { useToggle } from '@hooks';
import { ImageGalleryModal } from './image-gallery-modal';
import { concatenateAndReplace } from '@utils/test-helpers';
import { Button } from '@components/button';
import { Carousel } from '@components/carousel';
type Props = {
  galleryAssets: Pick<GalleryAsset, 'description' | 'url'>[];
  altTag: string;
  shouldShowAllImages: boolean;
  shouldWatermarkImage: boolean;
};
export const ImageMural: React.FC<Props> = t0 => {
  const $ = _c(54);
  const {
    galleryAssets,
    altTag,
    shouldShowAllImages,
    shouldWatermarkImage
  } = t0;
  let t1;
  if ($[0] !== galleryAssets) {
    t1 = galleryAssets.map(_temp).filter(notEmpty);
    $[0] = galleryAssets;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const galleryImages = t1;
  const {
    on,
    setOff,
    setOn
  } = useToggle(false);
  const onlyShowHero = galleryAssets.length < 5;
  const [galleryIndex, setGalleryIndex] = React.useState(0);
  let t2;
  if ($[2] !== setOn) {
    t2 = index => {
      setGalleryIndex(index);
      setOn();
    };
    $[2] = setOn;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectedGalleryAssetIndex = t2;
  let t3;
  let t4;
  if ($[4] !== on) {
    t3 = () => {
      if (on) {
        document.body.classList.add("modalActive");
      } else {
        document.body.classList.remove("modalActive");
      }
    };
    t4 = [on];
    $[4] = on;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  React.useEffect(t3, t4);
  let t5;
  if ($[7] !== setOff) {
    t5 = () => {
      const handleKeyUp = event => {
        bb14: switch (event.code) {
          case "Escape":
            {
              setOff();
              break bb14;
            }
          default:
        }
      };
      window.addEventListener("keyup", handleKeyUp);
      return () => {
        window.removeEventListener("keyup", handleKeyUp);
      };
    };
    $[7] = setOff;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  React.useEffect(t5, t6);
  let images;
  if ($[10] !== galleryAssets) {
    images = [];
    if (!Array.isArray(galleryAssets) || galleryAssets.length > 0) {
      galleryAssets.forEach(galleryAsset => {
        if (galleryAsset.url) {
          images.push({
            url: galleryAsset.url
          });
        }
      });
    }
    $[10] = galleryAssets;
    $[11] = images;
  } else {
    images = $[11];
  }
  let t7;
  if ($[12] !== altTag || $[13] !== galleryAssets.length || $[14] !== images || $[15] !== selectedGalleryAssetIndex || $[16] !== shouldShowAllImages) {
    t7 = galleryAssets.length > 1 && shouldShowAllImages && <div className="relative aspect-[3/2] h-full overflow-hidden rounded-xl mx-4 sm:hidden"><div className="aspect-[3/2]"><Carousel showDots={images.length < 10 && shouldShowAllImages} showArrows={shouldShowAllImages} className="relative block h-full w-full" onSlideChange={index_0 => setGalleryIndex(index_0)}>{images.map((image, index_1) => <button onClick={() => selectedGalleryAssetIndex(index_1)} key={index_1} className="relative block aspect-[3/2] h-auto w-full"><Image fill={true} src={image.url} alt={altTag} placeholder="blur" className="object-center object-cover" loader={imagekitLoader} blurDataURL={GRAY_PIXEL_DATA_URL} lazyBoundary="400px" sizes="100vw" priority={index_1 == 0} data-testid={concatenateAndReplace(`${altTag}-image-${index_1}`)} /></button>)}</Carousel></div></div>;
    $[12] = altTag;
    $[13] = galleryAssets.length;
    $[14] = images;
    $[15] = selectedGalleryAssetIndex;
    $[16] = shouldShowAllImages;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== galleryAssets.length || $[19] !== galleryImages.length || $[20] !== galleryIndex || $[21] !== setOn || $[22] !== shouldShowAllImages) {
    t8 = galleryAssets.length > 1 && shouldShowAllImages && <div><Button aria-label="expand" data-testid="@listing/view-gallery-photos-button" onClick={() => setOn()} variant="outlined" size="sm" className="absolute bottom-4 right-6 block bg-white focus:outline-none sm:hidden">{`${galleryIndex + 1} / ${galleryImages.length}`}</Button><Button aria-label="expand" data-testid="@listing/view-photos-button" onClick={() => setOn()} variant="outlined" size="sm" className="absolute bottom-4 right-4 z-10 hidden bg-white focus:outline-none sm:block">{`View ${galleryImages.length} Photos`}</Button></div>;
    $[18] = galleryAssets.length;
    $[19] = galleryImages.length;
    $[20] = galleryIndex;
    $[21] = setOn;
    $[22] = shouldShowAllImages;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== altTag || $[25] !== galleryImages || $[26] !== galleryIndex || $[27] !== on || $[28] !== setOff) {
    t9 = galleryImages.length > 0 && on && <ImageGalleryModal originalIndex={galleryIndex} modalIsOpen={on} closeModal={() => setOff()} galleryImages={galleryImages} altTag={altTag} />;
    $[24] = altTag;
    $[25] = galleryImages;
    $[26] = galleryIndex;
    $[27] = on;
    $[28] = setOff;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== altTag || $[31] !== galleryAssets[0] || $[32] !== galleryAssets.length || $[33] !== selectedGalleryAssetIndex || $[34] !== shouldWatermarkImage) {
    t10 = galleryAssets.length === 1 && <div className="sm:aspect-auto relative block aspect-[3/2] w-full hover:opacity-80 sm:hidden sm:aspect-3" onClick={() => selectedGalleryAssetIndex(0)}><Image alt={altTag} className="object-cover object-center" fill={true} placeholder="blur" blurDataURL={GRAY_PIXEL_DATA_URL} src={galleryAssets.length > 0 ? galleryAssets[0].url : ""} loader={imagekitLoader} sizes="100vw" priority={true} data-testid={concatenateAndReplace(`${altTag}-image`)} />{shouldWatermarkImage && <div><div className="absolute bottom-0 right-0 h-20 w-32 bg-gray-dark opacity-50 sm:rounded-md" /><div className="absolute bottom-0 right-0 flex h-20 w-32 flex-col justify-center"><img src="/assets/svg/iconPin.svg" alt="Savvy pin" className="mx-auto h-6 w-6" /></div></div>}</div>;
    $[30] = altTag;
    $[31] = galleryAssets[0];
    $[32] = galleryAssets.length;
    $[33] = selectedGalleryAssetIndex;
    $[34] = shouldWatermarkImage;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== altTag || $[37] !== galleryAssets[0] || $[38] !== galleryAssets[1] || $[39] !== galleryAssets[2] || $[40] !== galleryAssets[3] || $[41] !== galleryAssets[4] || $[42] !== galleryAssets.length || $[43] !== onlyShowHero || $[44] !== selectedGalleryAssetIndex || $[45] !== shouldShowAllImages || $[46] !== shouldWatermarkImage) {
    t11 = onlyShowHero || !shouldShowAllImages ? <button className="sm:aspect-auto relative hidden aspect-[3/2] w-full hover:opacity-80 sm:block sm:aspect-3" onClick={() => selectedGalleryAssetIndex(0)}><Image alt={altTag} className="object-cover object-center" fill={true} placeholder="blur" blurDataURL={GRAY_PIXEL_DATA_URL} src={galleryAssets.length > 0 ? galleryAssets[0].url : ""} loader={imagekitLoader} sizes="100vw" priority={true} data-testid={concatenateAndReplace(`${altTag}-image`)} />{shouldWatermarkImage && <div><div className="absolute bottom-0 right-0 h-20 w-32 bg-gray-dark opacity-50 sm:rounded-md" /><div className="absolute bottom-0 right-0 flex h-20 w-32 flex-col justify-center"><img src="/assets/svg/iconPin.svg" alt="Savvy pin" className="mx-auto h-6 w-6" /></div></div>}</button> : <div className="xl:aspect-auto hidden aspect-[3/2] w-full grid-rows-2 sm:grid sm:aspect-3 sm:grid-cols-4 sm:gap-2 xl:h-[25.5rem]"><button className="relative col-span-2 row-span-2 h-full w-full hover:opacity-80" onClick={() => selectedGalleryAssetIndex(0)}><Image alt={altTag} className="rounded-lg object-cover object-center" fill={true} placeholder="blur" blurDataURL={GRAY_PIXEL_DATA_URL} src={galleryAssets[0].url} loader={imagekitLoader} sizes="(min-width: 768px) 50vw, 100vw" priority={true} data-testid={concatenateAndReplace(`${altTag}-image`)} /></button><button className="relative col-span-1 hidden h-full w-full rounded-md hover:opacity-80 sm:block" onClick={() => selectedGalleryAssetIndex(1)}><Image alt={altTag} className="rounded-lg object-cover object-center" fill={true} placeholder="blur" blurDataURL={GRAY_PIXEL_DATA_URL} src={galleryAssets[1].url} loader={imagekitLoader} sizes="25vw" data-testid={concatenateAndReplace(`${altTag}-image`)} /></button><button className="relative col-span-1 hidden h-full w-full hover:opacity-80 sm:block" onClick={() => selectedGalleryAssetIndex(2)}><Image alt={altTag} className="rounded-lg object-cover object-center" fill={true} placeholder="blur" blurDataURL={GRAY_PIXEL_DATA_URL} src={galleryAssets[2].url} loader={imagekitLoader} sizes="25vw" data-testid={concatenateAndReplace(`${altTag}-image`)} /></button><button className="relative col-span-1 hidden h-full w-full hover:opacity-80 sm:block" onClick={() => selectedGalleryAssetIndex(3)}><Image alt={altTag} className="rounded-lg object-cover object-center" fill={true} placeholder="blur" blurDataURL={GRAY_PIXEL_DATA_URL} src={galleryAssets[3].url} loader={imagekitLoader} sizes="25vw" data-testid={concatenateAndReplace(`${altTag}-image`)} /></button><button className="relative col-span-1 hidden h-full w-full hover:opacity-80 sm:block" onClick={() => selectedGalleryAssetIndex(4)}><Image alt={altTag} className="rounded-lg object-cover object-center" fill={true} placeholder="blur" blurDataURL={GRAY_PIXEL_DATA_URL} src={galleryAssets[4].url} loader={imagekitLoader} sizes="25vw" data-testid={concatenateAndReplace(`${altTag}-image`)} /></button></div>;
    $[36] = altTag;
    $[37] = galleryAssets[0];
    $[38] = galleryAssets[1];
    $[39] = galleryAssets[2];
    $[40] = galleryAssets[3];
    $[41] = galleryAssets[4];
    $[42] = galleryAssets.length;
    $[43] = onlyShowHero;
    $[44] = selectedGalleryAssetIndex;
    $[45] = shouldShowAllImages;
    $[46] = shouldWatermarkImage;
    $[47] = t11;
  } else {
    t11 = $[47];
  }
  let t12;
  if ($[48] !== t10 || $[49] !== t11 || $[50] !== t7 || $[51] !== t8 || $[52] !== t9) {
    t12 = <div className="relative w-full">{t7}{t8}{t9}{t10}{t11}</div>;
    $[48] = t10;
    $[49] = t11;
    $[50] = t7;
    $[51] = t8;
    $[52] = t9;
    $[53] = t12;
  } else {
    t12 = $[53];
  }
  return t12;
};
function _temp(t0) {
  const {
    url
  } = t0;
  if (url) {
    return {
      url
    };
  } else {
    return null;
  }
}